export default __webpack_public_path__ + "static/media/metaIntro.b1e053cc.jpg";